let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("zy381")]).then(() => parcelRequire('5PZ1b'));